  $.fn.markdown.defaults.iconlibrary = 'fa';


// WEBPACK FOOTER //
// src/assets/metronic/src/js/framework/components/plugins/forms/bootstrap-markdown.init.js